import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';
import { useLanguage } from '../context/LanguageContext';

export default function Footer() {
  const { t } = useLanguage();

  return (
    <footer className="bg-gray-100 py-6 border-t text-center text-sm text-gray-700">
      <div className="max-w-2xl mx-auto px-4">
        <h2 className="text-xl font-semibold mb-2">{t.footer.titulofooter}</h2>
        <p className="mb-4">{t.footer.copyright}</p>

        <div className="flex justify-center gap-4 mb-4">
          <a
            href="https://www.linkedin.com/company/egovufsc/"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-blue-600 text-white p-2 rounded hover:bg-blue-700"
          >
            <LinkedInIcon />
          </a>
          <a
            href="https://www.instagram.com/conciliaufsc/"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-pink-500 text-white p-2 rounded hover:bg-pink-600"
          >
            <InstagramIcon />
          </a>
        </div>

        <p className="text-base ml-1.5">
          {t.footer.feedback}{' '}
          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLSeYCZqCGWhuWagbpR80ab9FimMi1xm04ZP5pyJbLai_u-Ud1g/viewform"
            target="_blank"
            rel="noopener noreferrer"
            className="underline text-blue-600 hover:text-blue-800"
          >
            {t.footer.here}
          </a>.
        </p>
      </div>
    </footer>
  );
}
